window.OSM = window.OSM ?? {};
/**
 * @type {IMapsProps}
 */
OSM.MapConfigs = OSM.MapConfigs ?? {}

/**
 * See MapCoreConfig.js for working example
 * @type {IMapProps}
 */
OSM.MapConfigs.property_search = {

}
